module.exports = __webpack_public_path__ + "static/media/hero3.db4649e6.jpeg";